import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import SplashScreen from '../../view/components/SplashScreen';
import { isAppHost } from '../utils/isAppHost';
import { pagePath } from '../utils/consts/pagePath';

const LandingPage = lazy(() => import('../../view/pages/LandingPage'));

export function LandingOrAppRedirect() {
  if (isAppHost(window.location.hostname)) {
    return <Navigate to={pagePath.login} replace />;
  }

  return (
    <Suspense fallback={<SplashScreen isLoading />}>
      <LandingPage />
    </Suspense>
  );
}
